<div class="container">
    <div class="tab-window">
        <h2>{{ call.description }}</h2>
    </div>
    <div class="tp-close">
        <button (click)="onCloseChildWindow()" mat-raised-button color="primary">
            {{ "Close" | translate }}
        </button>
    </div>
</div>
